// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"368":"04d40cdb","2251":"a09d6dc2","7014":"5e85e6db"}[chunkId] + ".chunk.css";
};